import type { ShowcaseCard } from '../../types';

interface ShowcaseSectionProps {
  cards: ShowcaseCard[];
}

const ShowcaseSection = ({ cards }: ShowcaseSectionProps) => {
  return (
    <section className="section container" id="visitanos">
      <div className="showcase-grid">
        {cards.map((card) => (
          <article key={card.id} className="showcase-card">
            <img src={card.image} alt={card.title} />
            <div className="showcase-card__content">
              <span>{card.tag}</span>
              <h2>{card.title}</h2>
              <p>{card.description}</p>
              <button type="button">Solicitar información</button>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default ShowcaseSection;
